"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderModeAwareDashboardLayoutSectionHeaderRenderer = void 0;
var componentDefinition_1 = require("../../componentDefinition");
var DashboardLayoutSectionHeaderRenderer_1 = require("./DashboardLayoutSectionHeaderRenderer");
var DashboardLayoutEditSectionHeaderRenderer_1 = require("./DashboardLayoutEditSectionHeaderRenderer");
/**
 * render function for DashboardLayoutSectionHeader respecting render mode
 *
 * @internal
 */
exports.renderModeAwareDashboardLayoutSectionHeaderRenderer = componentDefinition_1.renderModeAware({
    view: DashboardLayoutSectionHeaderRenderer_1.DashboardLayoutSectionHeaderRenderer,
    edit: DashboardLayoutEditSectionHeaderRenderer_1.DashboardLayoutEditSectionHeaderRenderer,
});
//# sourceMappingURL=RenderModeAwareDashboardLayoutSectionHeaderRenderer.js.map